import React from 'react';
import { Schema } from '../../schema';
import { BreadcrumbsContext } from '../context';
import { BreadcrumbsItem } from '../model';

export const BreadcrumbsSchema: React.FC<{ items: BreadcrumbsItem[] }> = ({ items }) => {
  const { hostname } = React.useContext(BreadcrumbsContext);

  const schema = React.useMemo(
    () => ({
      '@type': 'BreadcrumbList',
      itemListElement: items.map(({ label, path }, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        item: {
          '@id': `${hostname}${path}`,
          name: label,
        },
      })),
    }),
    [hostname, items],
  );

  return <Schema schema={schema} />;
};
